import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'projectMediacontactPartnerFeatureClippings',
  urlRoot: '/project_mediacontact_partner_feature_clippings'
})
